
import { computed, defineComponent } from "vue";
import DiamondListEntry from "@/components/DiamondListEntry.vue";
import useStore from "@/composables/useStore";
import { Diamond } from "@/api/Diamond";

export default defineComponent({
    name: "DiamondList",
    components: {
        DiamondListEntry
    },
    setup() {
        const {
            actions: { setDiamond },
            computed: { filteredDiamonds, selectedDiamond }
        } = useStore();

        const hasDiamonds = computed(() => filteredDiamonds.value.length > 0);

        const sortedDiamonds = computed(() =>
            filteredDiamonds.value.sort((a, b) => a.price - b.price)
        );

        function handleSelectDiamond(diamond: Diamond) {
            setDiamond(diamond);
        }

        return {
            filteredDiamonds,
            hasDiamonds,
            handleSelectDiamond,
            selectedDiamond,
            sortedDiamonds
        };
    }
});
